import React from 'react';
import { BubbleNavigation } from '../BubbleUI';
import {
  canSetSuperAdminConfig,
  canModifyBrandSettings,
  canViewPropertiesTab,
  canViewUserManagementTab,
} from '@go-shared/lib/permissions';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { useUserInfo } from '@go-client/context/UserInfoContext';
import {
  resolveBrandSettingsPath,
  resolvePropertiesPath,
  resolveSuperAdminSettingsPath,
  resolveUserManagementPath,
} from '@go-client/routes';

export default function PropertiesNavigation(props: {
  active: 'properties' | 'user-management' | 'brand-config' | 'super-admin-config';
}) {
  const serverInfo = useServerInfo();
  const { user } = useUserInfo();

  return (
    <BubbleNavigation
      items={[
        {
          name: 'Properties',
          to: resolvePropertiesPath(),
          hide: !canViewPropertiesTab(user, serverInfo),
          active: props.active === 'properties',
        },
        {
          name: 'Users',
          to: resolveUserManagementPath(),
          hide: !canViewUserManagementTab(user, serverInfo),
          active: props.active === 'user-management',
        },
        {
          name: 'Settings',
          to: resolveBrandSettingsPath(),
          hide: !canModifyBrandSettings(user, serverInfo),
          active: props.active === 'brand-config',
        },
        {
          name: 'Super Admin',
          to: resolveSuperAdminSettingsPath(),
          hide: !canSetSuperAdminConfig(user),
          active: props.active === 'super-admin-config',
        },
      ]}
    />
  );
}
